import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const { userPermissions } = useSelector((state) => state.auth);

  const hasPermission = (permissionName) => {
    if (!userPermissions || userPermissions.length === 0) {
      return false;
    }
    
    return userPermissions.some(permission => permission.name === permissionName);
  };

  const hasAnyPermission = (permissionNames) => {
    if (!userPermissions || userPermissions.length === 0) {
      return false;
    }
    
    return permissionNames.some(permissionName => 
      userPermissions.some(permission => permission.name === permissionName)
    );
  };

  const hasAllPermissions = (permissionNames) => {
    if (!userPermissions || userPermissions.length === 0) {
      return false;
    }
    
    return permissionNames.every(permissionName => 
      userPermissions.some(permission => permission.name === permissionName)
    );
  };

  return {
    userPermissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  };
};
